import { combineReducers } from 'redux';
import { accountsRootApi, agentRootApi, servicesRootApi, usersRootApi } from './api.ts';
import layoutReducer from './slices/layoutSlice.ts';

export const reducers = {
  [servicesRootApi.reducerPath]: servicesRootApi.reducer,
  [usersRootApi.reducerPath]: usersRootApi.reducer,
  [accountsRootApi.reducerPath]: accountsRootApi.reducer,
  [agentRootApi.reducerPath]: agentRootApi.reducer,
  layout: layoutReducer,
};

const rootReducer = combineReducers(reducers);

export default rootReducer;
